<div class="row" *ngIf="StatisticsInfo">
    <!-- 1 -->
    <div class="col-lg-4 col-sm-6">
        <mat-card class="cardWithShadow text-center">
            <mat-card-content class="p-20">
                <h5 class="f-s-16 f-w-400 mat-subtitle-1 m-b-10"> {{'numberOfAgents'|translate}}</h5>
                <div style="width: 90px; margin: 0 auto">
                    <apx-chart [series]="spark1Chart.series" [chart]="spark1Chart.chart" [colors]="spark1Chart.colors">
                    </apx-chart>
                </div>
            </mat-card-content>
            <div class="p-8 b-t-1">
                <mat-card-title class="f-s-16">{{StatisticsInfo?.numberOfAgents}}</mat-card-title>
            </div>
        </mat-card>
    </div>

    <!-- 2 -->
    <div class="col-lg-4 col-sm-6">
        <mat-card class="cardWithShadow text-center">
            <mat-card-content class="p-20">
                <h5 class="f-s-16 f-w-400 mat-subtitle-1 m-b-10"> {{'numberOfWorkShops'|translate}}</h5>
                <div style="width: 90px; margin: 0 auto">
                    <apx-chart [series]="spark2Chart.series" [chart]="spark2Chart.chart" [colors]="spark2Chart.colors">
                    </apx-chart>
                </div>
            </mat-card-content>
            <div class="p-8 b-t-1">
                <mat-card-title class="f-s-16">{{StatisticsInfo?.numberOfWorkShops}}</mat-card-title>
            </div>
        </mat-card>
    </div>
    <!-- 3 -->
    <div class="col-lg-4 col-sm-6">
        <mat-card class="cardWithShadow text-center">
            <mat-card-content class="p-20">
                <h5 class="f-s-16 f-w-400 mat-subtitle-1 m-b-10"> {{'numberOfClients'|translate}}</h5>
                <div style="width: 90px; margin: 0 auto">
                    <apx-chart [series]="spark3Chart.series" [chart]="spark3Chart.chart" [colors]="spark3Chart.colors">
                    </apx-chart>
                </div>
            </mat-card-content>
            <div class="p-8 b-t-1">
                <mat-card-title class="f-s-16">{{StatisticsInfo?.numberOfClients}}</mat-card-title>
            </div>
        </mat-card>
    </div>
</div>